import React from 'react';
import { InlineSVG } from '../../../../../../Components/Icons';
import { colors } from '../../../../../../globalStyles';
import { AssessmentIndexAiSummary } from './AssessmentInsights.types';
import {
  EmptyStateP,
  IconWrap,
  InsightsGridDiv,
  InsightsModal,
  InsightsSectionDiv,
  ModalBodyDiv,
  ModalHeaderDiv,
  RecommendationsOl,
  SectionBodyDiv,
} from './AssessmentInsights.styles';
import { Markdown } from '../Markdown';

type AssessmentInsightsProps = {
  aiSummary: AssessmentIndexAiSummary;
};

export const InsightsSections = ({ aiSummary }: AssessmentInsightsProps): React.ReactElement => {
  const summary = aiSummary.summary.trim();
  const recommendations = aiSummary.recommendations.filter(
    recommendation => recommendation.trim().length > 0
  );

  return (
    <InsightsGridDiv>
      <InsightsSectionDiv>
        <h3>What's Going On</h3>
        <SectionBodyDiv>
          {summary ? (
            <Markdown>{summary}</Markdown>
          ) : (
            <EmptyStateP>No assessment insights are available for this student.</EmptyStateP>
          )}
        </SectionBodyDiv>
      </InsightsSectionDiv>
      <InsightsSectionDiv>
        <h3>Recommended Next Steps</h3>
        <SectionBodyDiv>
          {recommendations.length ? (
            <RecommendationsOl>
              {recommendations.map((recommendation, index) => (
                <li key={index}>
                  <Markdown inline>{recommendation}</Markdown>
                </li>
              ))}
            </RecommendationsOl>
          ) : (
            <EmptyStateP>No recommended next steps are available for this student.</EmptyStateP>
          )}
        </SectionBodyDiv>
      </InsightsSectionDiv>
    </InsightsGridDiv>
  );
};

type AssessmentInsightsModalProps = AssessmentInsightsProps & {
  isOpen: boolean;
  onClose: () => void;
};

export const AssessmentInsightsModal = ({
  aiSummary,
  isOpen,
  onClose,
}: AssessmentInsightsModalProps): React.ReactElement => (
  <InsightsModal isOpen={isOpen} onClose={onClose} size="l" style={{ padding: 0 }}>
    <ModalHeaderDiv>
      <IconWrap aria-hidden="true">
        <InlineSVG icon="magic-wand" size={22} fill={colors.white} />
      </IconWrap>
      Insights &amp; Recommended Actions
    </ModalHeaderDiv>
    <ModalBodyDiv>
      <InsightsSections aiSummary={aiSummary} />
    </ModalBodyDiv>
  </InsightsModal>
);
